import type { RecordMutationEvent } from "shared/services/recordMutationBus";

const channel = typeof BroadcastChannel !== "undefined" ? new BroadcastChannel("primum-record-mutations") : null;
const TAB_ID = globalThis.crypto?.randomUUID?.() ?? String(Math.random());

export const publishRemote = (event: RecordMutationEvent) => {
    const { table, operation, ids, source } = event;
    channel?.postMessage({ origin: TAB_ID, event: { table, operation, ids, source } });
};

export const subscribeRemote = (handler: (event: RecordMutationEvent) => void) => {
    if (channel) {
        channel.onmessage = ({ data }) => {
            if (data?.origin !== TAB_ID && data?.event) {
                handler(data.event);
            }
        };
    }
};
